<template>
    <div>
        <CList @FiltrarC="Lista" :pConfigList="ConfigList" :pFiltro="Filtro" :segurity="segurity">
            <template slot="Filtros">
                <p><span class="text-black bold">Costo Total de Producción Aproximado: </span>$ {{ $formatNumber(CostoTotalProduccion) }}</p>
            </template>
            <template slot="header">
                <th :class="StyleTh+' text-center'">#</th>
                <th :class="StyleTh">Producto</th>
                <th :class="StyleTh">Cantidad</th>
                <th :class="StyleTh">Costo</th>
                <th :class="StyleTh">Total</th>
                <th :class="StyleTh+' text-center'">Acciones</th>
            </template>
            <template slot="body">
                <tr v-for="(item,index) in ListaArrayRows" :key="index">
                    <td class="text-center"><p :class="StyleTd">{{(index+1)}}</p></td>
                    <td><h6 :class="StylePr">{{ item.Nombre }}</h6></td>
                    <td><p :class="StyleTd">{{ item.Cantidad }}</p></td>
                    <td><p :class="StyleTd">$ {{ item.Costo }}</p></td>
                    <td><p :class="StyleTd">$ {{ item.PrecioTotal }}</p></td>
                    <td class="align-middle text-end">
						<CBtnAccion :pShowBtnEdit="true" :pShowBtnDelete="true" :pIsModal="true" :pId="item.IdBancoImagenxProducto" :pEmitSeccion="ConfigList.EmitSeccion" :segurity="segurity">
							<template slot="btnaccion">
                            </template>
						</CBtnAccion>
					</td>
                </tr>
                <CSinRegistros :pContIF="ListaArrayRows.length" :pColspan="6"></CSinRegistros>
            </template>
        </CList>
        <CModal :pConfigModal="ConfigModal" :poBtnSave="oBtnSave">
            <template slot="Form">
                <FormModal :poBtnSave="oBtnSave"></FormModal>
            </template>
        </CModal>
    </div>
</template>
<script>
import Configs from '@/helpers/VarConfig.js';
import FormModal from '@/views/catalogos/bancoImagenProducto/BancoImagenProductoModal.vue';
const EmitEjecuta = 'seccionProductoBancoImagen';
const EmitEjecuta2 = 'seccionProductoBancoImagenEditar';
export default {
    name:'ListaProductoBancoImagen',
    props:['pObjBancoImagen'],
    components:{FormModal},
    data() {
        return {
            ConfigList:{
                Title: 'Productos',
                IsModal: false,
                ShowLoader: true,
                ClassLoad:true,
                EmitSeccion: EmitEjecuta2,
                BtnReturnShow: true,
                TitleFirst: this.$limitCharacters(this.pObjBancoImagen.Descripcion,60),
                GoRoute:'BancoImagenProductosForm',
                Obj:{IdBancoImagen:this.pObjBancoImagen.IdBancoImagen,Descripcion:this.pObjBancoImagen.Descripcion}
            },
            Filtro:{
                Nombre: '',
                Pagina: 1,
                Entrada: 25,
                TotalItem: 0,
                Placeholder: 'Buscar..',
            },
            ConfigModal:{
                ModalTitle: "Formulario Producto",
                ModalNameId: 'ModalForm',
                EmitSeccion: EmitEjecuta2,
                // Obj:{objProductoPresentacion:{}},
                ModalSize:'lg'
            },
            oBtnSave: {
                Toast: 0,
                IsModal: true,
                DisableBtn: false,
                EmitSeccion: EmitEjecuta2,
            },
            segurity: {},
            obj: {},
            ListaArrayRows: [],               
            StyleTh: Configs.stylesTable.StyleTh,
            StylePr: Configs.stylesTable.StylePr,
            StyleTd: Configs.stylesTable.StyleTd,
            BancoImagenProductos:[],
            CostoTotalProduccion:0
        }
    },
    methods: {
        async Lista(){
            // this.CostoTotalProduccion=0;
            this.ConfigList.ShowLoader=true;
            this.$http.get("bancoImagenProductos",{
                params:{
                    IdBancoImagen:this.pObjBancoImagen.IdBancoImagen,
                    TxtBusqueda:this.Filtro.Nombre,
                    Pag:this.Filtro.Pagina,
                    Entrada:this.Filtro.Entrada
                }
            }).then((res)=>{
                this.Filtro.Pagina      = res.data.data.current_page;
                this.Filtro.TotalItem   = res.data.data.total;
                this.ListaArrayRows=res.data.data.data;
                this.segurity = res.data.segurity;
                // this.SumarCostoTotal();
            }).finally(()=>{
                this.ConfigList.ShowLoader=false;
            })
        },
        Eliminar(Id){
            this.$swal(Configs.configEliminar).then((result) =>
            {
                if(result.value)
                {
                    this.$http.delete('bancoImagenProductos/'+Id
                    ).then((res) => {
                        this.$swal(Configs.configEliminarConfirm);
                        this.RecuperarTodosProductos();
                        this.Lista();
                    }).catch(err => {
                        this.$toast.error(err.response.data.message);
                    });
                } 
            });
        },
        Regresar(){
            this.$router.push({name:'galeriaImagen',params:{}});
        },
        RecuperarTodosProductos(){
            this.CostoTotalProduccion=0;
            this.$http.get('bancoImagenProductosSimple',{
                params:{
                    IdBancoImagen:this.pObjBancoImagen.IdBancoImagen
            }}).then((res)=>{
                this.BancoImagenProductos=res.data.data;
                this.SumarCostoTotal();
            })
        },
        SumarCostoTotal(){
            this.BancoImagenProductos.forEach(element => {
                this.CostoTotalProduccion+=parseFloat(element.PrecioTotal);
            });
            parseFloat(this.CostoTotalProduccion).toFixed(2);
        }
    },
    created() {
        this.bus.$off('List_'+EmitEjecuta2);
        this.bus.$off('Delete_'+EmitEjecuta2);
        this.bus.$off('EmitReturn');
    },
    mounted() {
        this.RecuperarTodosProductos();
        this.Lista();

        this.bus.$on('List_'+EmitEjecuta2,()=>
        {
            this.RecuperarTodosProductos();
            this.Lista();
        });
        this.bus.$on('Delete_'+EmitEjecuta2,(Id)=>
        {
            this.Eliminar(Id);
        });
        this.bus.$on('EmitReturn',()=>
        {
            this.Regresar();
        });
    },
}
</script>